import { GET_DUPLICATE_REPORTS_API_SUCCESS_STATUS_CODE, GET_DUPLICATE_REPORTS_API } from '../constants/AppConstants';

export default async (address) => {
  try {
    const response = await fetch(`${GET_DUPLICATE_REPORTS_API}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...address,
      }),
    });
    if (response.status !== GET_DUPLICATE_REPORTS_API_SUCCESS_STATUS_CODE) return ({ ok: false, error: response.status });
    const json = await response.json();
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
